import {Authenticated} from './middleware'

export default [
  {
    name: 'heatMarker',
    path: '/',
    redirect: {name: 'heatMarker.list'},
    component: () => import ('../../views/heatMarker'),
    meta: {
      title: 'Разметчик термограмм',
      back: 'cpanel.dashboard',
      middleware: Authenticated
    },
    children: [
      {
        name: 'heatMarker.list',
        path: 'list',
        component: () => import ('../../views/heatMarker/List'),
        meta: {
          title: 'Разметчик термограмм',
          back: 'cpanel.dashboard',
          middleware: Authenticated,
          permission: 'can.manage.users'
        }
      },
      {
        name: 'heatMarker.item',
        path: ':id?',
        component: () => import ('../../views/heatMarker/Item'),
        meta: {
          title: 'Просмотор термограмм',
          back: 'complexExercises.list',
          middleware: Authenticated,
          permission: 'can.manage.users'
        }
      }
    ]
  }

];

